function TransformBusiness(initialValue = []) {
    return initialValue.map(item => ({
      id: item.id,
      ...item.attributes,
      Image: item.attributes.Image?.data?.attributes?.url,
     
    }))
  }
  
  export default TransformBusiness